export default __webpack_public_path__ + "static/media/bannerBg.7e9a6678.png";